export enum SupportedNetworkId {
  Ethereum = 1,
  Polygon = 137,
  Base = 8453,
  ArbitrumSepolia = 421614,
}
